var storefrontApp = angular.module("storefrontApp");
storefrontApp.service('inspirationService',
    ['$http', function ($http) {
        return {
            getProjectById: function (projectId) {
                return $http.get('storefrontapi/learningcenter/projectbyid?projId=' + projectId);
            },
            getCollections: function (count) {
                return $http.get('storefrontapi/learningcenter/getCollections?count=' + count);
            },
            getCollectionsById: function (collectionId) {
                return $http.get('storefrontapi/learningcenter/getcollectionsbyid?collectionId=' + collectionId);
            },
            getcollectionsbycategoryid: function (categoryId) {
                return $http.get('storefrontapi/learningcenter/getcollectionsbycategoryid?categoryId=' + categoryId);
            },
            getCollectionItemsByCollectionId: function (collectionId) {
                return $http.get('storefrontapi/learningcenter/getcollectionitemsbycollectionid?collectionId=' + collectionId);
            },
            getCollectionCategories: function () {
                return $http.get('storefrontapi/learningcenter/getcollectioncategories');
            },
            getCategoryById: function (categoryId) {
                return $http.get('storefrontapi/learningcenter/getcategorybyid?id=' + categoryId);
            },
            isNewCollection: function (CreatedDate) {
                var currentDate = new Date();
                var twoMonthsAgo = new Date();
                twoMonthsAgo.setMonth(currentDate.getMonth() - 2);
                var providedDate = new Date(CreatedDate);
                var year = providedDate.getFullYear();
                var month = providedDate.getMonth() + 1;
                if (month === 1 || month === 2) {
                    if (currentDate.getFullYear() == year) {
                        return providedDate >= twoMonthsAgo && providedDate <= currentDate;
                    }
                }
                else {
                    return providedDate >= twoMonthsAgo && providedDate <= currentDate;
                }
            }
        }
    }
    ]);
